export const UNINSURED_OPTION = "No insurance";
export const OUT_OF_NETWORK_INSURANCE_OPTION = "Insurance isn’t on the list";
export const CATCH_ALL_INSURANCE_OPTIONS = [UNINSURED_OPTION, OUT_OF_NETWORK_INSURANCE_OPTION];

export const InsuranceCarrierEnum = {
  CDPHP: "CDPHP",
  CDPHP_MEDICAID: "CDPHP Medicaid",
  MVP: "MVP",
  MVP_HEALTHCARE: "MVP Health Care",
  MVP_MEDICAID: "MVP Medicaid",
  MVP_MEDICARE: "MVP Medicare",
  OTHER: "Other",
} as const;
